import { apiClient } from "../client";
import { API_ENDPOINTS } from "../endpoints";
import type { AdminTeam, AdminTeamDetail, Pagination } from "@/types/api.types";

export interface TeamFilters {
  search?: string;
  page?: number;
  limit?: number;
}

export interface AdminUpdateTeamRequest {
  name?: string;
  formation?: string;
  captainId?: number | null;
  isLocked?: boolean;
  totalPoints?: number;
}

export const teamsService = {
  getAllTeams: async (
    filters?: TeamFilters,
  ): Promise<{ teams: AdminTeam[]; pagination: Pagination }> => {
    const params = new URLSearchParams();
    if (filters?.search) params.append("search", filters.search);
    if (filters?.page) params.append("page", filters.page.toString());
    if (filters?.limit) params.append("limit", filters.limit.toString());
    const query = params.toString();
    return await apiClient.get(
      `${API_ENDPOINTS.TEAMS.ADMIN_ALL}${query ? `?${query}` : ""}`,
    );
  },

  getTeamById: async (id: number): Promise<AdminTeamDetail> => {
    return await apiClient.get(API_ENDPOINTS.TEAMS.ADMIN_DETAIL(id));
  },

  updateTeam: async (
    id: number,
    data: AdminUpdateTeamRequest,
  ): Promise<AdminTeam> => {
    return await apiClient.patch(API_ENDPOINTS.TEAMS.ADMIN_UPDATE(id), data);
  },

  deleteTeam: async (id: number): Promise<{ message: string }> => {
    return await apiClient.delete(API_ENDPOINTS.TEAMS.ADMIN_DELETE(id));
  },
};
